import { CommonModule } from "@angular/common";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { Bug, ChartColumnBig, ChartPie, CircleUser, Factory, GitFork, LandPlot, Layers, LogOut, LucideAngularModule, LucideIconData, ScrollText, UserCheck, UsersRound, ClipboardList, Wrench } from "lucide-angular";
import { SharedModule } from "../../shared.module";

export interface NavigationLink {
  label: string;
  route: string;
  action?: () => Promise<void>;
  icon?: string; // SVG icon path or content,
  enabled?: boolean;
  tooltip?: string; // Tooltip text
}

@Component({
  selector: "app-navigation-group",
  templateUrl: "./navigation-group.component.html",
  styleUrls: ["./navigation-group.component.scss"],
  imports: [SharedModule, CommonModule, RouterLink, RouterLinkActive, LucideAngularModule]
})
export class NavigationGroupComponent {
  @Input() title: string = "";
  @Input() links: NavigationLink[] = [];
  @Input() collapsed: boolean = false;
  @Input() icon?: string;
  @Input() color?: string;

  @Output() linkClicked = new EventEmitter<void>();

  icons: Record<string, LucideIconData> = {
    chartPie: ChartPie,
    bug: Bug,
    factory: Factory,
    gitFork: GitFork,
    users: UsersRound,
    account: CircleUser,
    logout: LogOut,
    userCheck: UserCheck,
    area: LandPlot,
    layers: Layers,
    chartColumnBig: ChartColumnBig,
    scrollText: ScrollText,
    clipboardList: ClipboardList,
    // manutenzioni interne: una chiave inglese, distinta dal documento dei contratti
    wrench: Wrench
  };

  onLinkClick(): void {
    this.linkClicked.emit();
  }
} 